<script setup></script>

<template>
  <div id="tag">
    <button-router></button-router>
    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#tag {
  height: 100%;
}
</style>
